import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Observable } from 'rxjs';

import { skipApiKey } from '../../../core/services/http.context';
import { MessagingEnvironmentService } from '../../../core/services/messaging-environment.service';
import { GiphyModalComponent } from '../components/giphy/giphy.component';
import { IGif } from '../interfaces/IGif';

@Injectable()
export class GiphyService {
  constructor(private httpClient: HttpClient, public dialog: MatDialog, private env: MessagingEnvironmentService) {}

  getSearchByQueryGifs(query: string, page: number, size: number): Observable<{ data: IGif[] }> {
    return this.httpClient.get<{ data: IGif[] }>(
      `//api.giphy.com/v1/gifs/search?api_key=${this.env.env.giphyKey}&q=${query}&limit=${size}&offset=${page * size}`,
      {
        context: skipApiKey(),
      }
    );
  }

  getTrendingGifs(page: number, size: number): Observable<{ data: IGif[] }> {
    return this.httpClient.get<{ data: IGif[] }>(
      `//api.giphy.com/v1/gifs/trending?api_key=${this.env.env.giphyKey}&limit=${size}&offset=${page * size}`,
      {
        context: skipApiKey(),
      }
    );
  }

  openGiphy(): void {
    this.dialog.open(GiphyModalComponent, {
      width: '500px',
      panelClass: 'custom-close-button-modal',
    });
  }
}
